export default __webpack_public_path__ + "static/media/menu11_hl.acbff647.png";